import { Box } from '@mui/material';

import type { TabPanelProps } from '../../utils/types';

//Tab panel component
export function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...(other ?? {})}
      sx={{ mt: 4 }}
    >
      {value === index && <Box sx={{ p: 0, position: 'relative' }}>{children}</Box>}
    </Box>
  );
}

export function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
